export const deviceTypes = [
  { label: "Laptop", value: "laptop" },
  { label: "Mobile", value: "mobile" },
];
